export default "__VITE_ASSET__d90eb0b3__"